import parsePhoneNumberFromString from "libphonenumber-js";

// -----------------------------------------------------------------------------
// Format date
// -----------------------------------------------------------------------------
export function useFormatDate(
  timestamp,
  options = {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  },
) {
  if (!timestamp) {
    return null;
  }

  // TOO TMP FIX !
  if (Number.isInteger(timestamp)) {
    timestamp *= 1000;
  } else {
    timestamp = Date.parse(timestamp);
  }
  const date = new Date(timestamp);

  return Intl.DateTimeFormat("fr-FR", options).format(date);
}

/**
 * Array to object
 */

export function useArrayToObject(data, index) {
  if (!data) {
    return {};
  }
  return data.reduce(
    (output, element) => ((output[element[index]] = element), output),
    {},
  );
}

/**
 * Take a array of words(that can be null) and add "," and "et" character to make a readable sentence
 * @param {array<String|null>} words
 * @returns {String}
 */
export function useListWording(words) {
  const sentence = [];
  words.forEach((word, i) => {
    if (word) {
      if (sentence.length) {
        if (i === words.length - 1) {
          sentence.push(" et ");
        } else if (i !== 0) {
          sentence.push(", ");
        }
      }
      sentence.push(word);
    }
  });
  return sentence.join("");
}

export function useAdminCode(adminId, lowercase = true) {
  if (!adminId) {
    return null;
  }

  let code = adminId.substring(3);

  switch (code.toLowerCase()) {
    case "gp":
      code = "971";
      break;
    case "mq":
      code = "972";
      break;
    case "gf":
      code = "973";
      break;
    case "re":
      code = "974";
      break;
    case "pm":
      code = "975";
      break;
    case "yt":
      code = "976";
      break;
    case "bl":
      code = "977";
      break;
    case "mf":
      code = "978";
      break;
    case "wf":
      code = "986";
      break;
    case "pf":
      code = "987";
      break;
    default:
      break;
  }

  return lowercase ? code : code.toUpperCase();
}

export function useTimestampToUnix(timestamp) {
  return Math.floor(timestamp / 1000);
}

export function PhoneHelper(number, country) {
  const phoneNumber = parsePhoneNumberFromString(number, country);
  if (!phoneNumber || !phoneNumber.isValid()) return null;

  return {
    number: phoneNumber.number, // E164 : +33102030405
    international: phoneNumber.formatInternational(), // +33 1 02 03 04 05
    national: phoneNumber.formatNational(), // 01 02 03 04 05
    country: phoneNumber.country, // FR, US...
  };
}

// export function useImageUrl(img) {
//   return img
//     ? `${import.meta.env.VITE_API_URL}photo/{img_size}/${img}.{img_type}`
//     : null;
// }

export function useImageUrl(url, size = 8, extension = "webp") {
  return url
    ? url.replace("{img_size}", size).replace("{img_type}", extension)
    : null;
}

export async function useDrawShape(alias) {
  return useFetchApi()
    .get(`v1/city/shape/${alias}`)
    .then((res) => res.body)
    .catch(() => null);
}

export function useTransformCapacity(value) {
  if (!value) return value;

  if (value === 1) return 1;
  if (value <= 10) return 10;
  if (value <= 50) return 50;
  if (value <= 250) return 250;

  return 251;
}

/**
 * Détection des url/email/phone dans un texte
 */

const emailRegex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi;

const urlRegex = /\b(?:https?:\/\/|www\.)\S+/gi;

const phoneRegex =
  /(?:0[1-9](?:[ .\u00A0-]*\d{2}){4}|(?:\+33|33)[ .\u00A0-]*[1-9](?:[ .\u00A0-]*\d{2}){4})(?!\d)/g;

function normalizeText(text) {
  return text.replace(/[^a-z0-9àâçéèêëîïôûùüÿñæœ]/gi, " ");
}

function deleteUrls(text) {
  return text.replace(/\b(?:https?:\/\/|www\.)\S+/gi, " ");
}

function detectEmails(text) {
  return text.match(emailRegex) || [];
}

function detectUrls(text) {
  return text.match(urlRegex) || [];
}

function detectPhones(text) {
  const withoutUrls = deleteUrls(text);
  const cleaned = normalizeText(withoutUrls);

  return cleaned.match(phoneRegex) || [];
}

export function useContentDetection(text) {
  if (typeof text !== "string" || !text) {
    return {
      phones: [],
      emails: [],
      urls: [],
    };
  }

  return {
    phones: detectPhones(text),
    emails: detectEmails(text),
    urls: detectUrls(text),
  };
}
